import React, { useState } from "react";
import axios from "axios";
import './css/ZomatoRagChatbot.css'

const DEFAULT_CHAT_MODEL = "claude-3-haiku-20240307";

function WeatherRouter() {
  const [form, setForm] = useState({
    anthropic_api_key: "",
    model: "",
    ORS_API_KEY: "",
    WEATHER_API_KEY: "",
    query: "",
  });
  const [chatModel, setChatModel] = useState(DEFAULT_CHAT_MODEL);
  const [error, setError] = useState("");
  const [message, setMessages] = useState("Welcome! Please enter config and chat.")

  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const isValid =
    form.anthropic_api_key.trim() &&
    chatModel.trim() &&
    form.ORS_API_KEY.trim() &&
    form.WEATHER_API_KEY.trim() &&
    form.query.trim();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!isValid) {
      setError("Please fill all configuration fields before chatting.");
      return;
    }

    const payload = {
        model_api: form.anthropic_api_key,
        model : chatModel,
        ors_api : form.ORS_API_KEY,
        weather_api : form.WEATHER_API_KEY,
        message : form.query,
    }

    setLoading(true);
    setError("")
    
    try {
      const apiChatsUrl = process.env.REACT_APP_API_WEATHER_ROUTER

      const response = await axios.post(`${apiChatsUrl}`, payload);
      // handle success (show result, toast, etc.)
      if (response.data.success)
        setMessages(response.data.reply)
      else
        setError(response.data.reply)
    } catch (err) {
      // handle error
      console.error(err);
      setError(err.response?.data?.error || err.message || "Server error during chat.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="zomato-rag-bg">
      <div className="zomato-rag-card">
        <h2 className="zomato-title">Trip Planner</h2>
        <p className="zomato-desc">
          AI powered chatbot that help you plan your trip by checking the weather condition, routes and perfect resting stops.
        </p>
            <form
            onSubmit={onSubmit} 
            className="zomato-config-form">
                <div className="config-group">
                    <label>
                        Model API Key
                        <input
                        type="password"
                        name="anthropic_api_key"
                        value={form.anthropic_api_key}
                        onChange={onChange}
                        required
                        />
                    </label>

                    <label>
                        Chat model
                        <select
                            value={chatModel}
                            onChange={(e) => setChatModel(e.target.value)}
                            // disabled={loadingChat}
                            className="options"
                        >
                            <option value="claude-3-haiku-20240307">Claude 3 Haiku (recommended)</option>
                            <option value="claude-3-sonnet-20240229">Claude 3 Sonnet</option>
                            <option value="gpt-3.5-turbo">OpenAI GPT-3.5 Turbo</option>
                        </select>
                    </label>

                    <label>
                        ORS API Key
                        <input
                        type="password"
                        name="ORS_API_KEY"
                        value={form.ORS_API_KEY}
                        onChange={onChange}
                        required
                        />
                    </label>

                    <label>
                        Weather API Key
                        <input
                        type="password"
                        name="WEATHER_API_KEY"
                        value={form.WEATHER_API_KEY}
                        onChange={onChange}
                        required
                        />
                    </label>

                    <label>
                        Query
                        <textarea
                        name="query"
                        rows={4}
                        placeholder="Describe your trip or planning request"
                        value={form.query}
                        onChange={onChange}
                        required
                        />
                    </label>

                    <button type="submit" disabled={!isValid || loading}>
                        {loading ? "Planning..." : "Plan"}
                    </button>
                </div>
            </form>
            {error && <div className="error-box">{error}</div>}
            <div className="msg-box">{message}</div>
        </div>
    </div>
  );
}

export default WeatherRouter;
